export const canShareCustomerBooking = (user) =>
  Boolean(user && Array.isArray(user.roles) && user.roles.some((role) =>
    ["super_admin", "admin", "staff"].includes(role),
  ));

export const customerBookingCode = (nodeId, customerId) => {
  if (![nodeId, customerId].every((id) => typeof id === "string" && id.length > 0 && !id.includes("/") && Array.from(id).every((char) => char.charCodeAt(0) >= 32))) {
    throw new Error("Invalid customer identity");
  }
  return `nodes/${nodeId}/customers/${customerId}`;
};

export const customerBookingUrl = (portalUrl, nodeId, customerId, service = "sleep-test") => {
  if (!["sleep-test", "cpap"].includes(service)) throw new Error("Invalid booking service");
  const url = new URL(portalUrl);
  if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) {
    throw new Error("Invalid patient portal URL");
  }
  url.pathname = "/reserve";
  url.search = "";
  url.hash = "";
  url.searchParams.set("customer", customerBookingCode(nodeId, customerId));
  url.searchParams.set("service", service);
  return url.href;
};
